module.exports = __webpack_public_path__ + "static/media/account-settings.1bed50e8.png";